import CreateClientComponent from "@components/CreateClientComponent/CreateClientComponent";
import { Stack } from "@mui/material";
import { CreateModalContext } from "layouts/appLayout/layout";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import InfoSupp from "../InfoClient/InfoClient";
import "./index.scss";
import { motion, AnimatePresence } from "framer-motion";

const CompanyClientDetails = ({
  companyData,
  selectedClientId,
  selectedClientData,
  clientsData,
  handleClientChange,
  register,
  idUserClient,
  isUpdate,
  initialValues,
}) => {
  const { numTVA, phone, rm, siren, siret, typeClient, name, address, email } =
    isUpdate ? initialValues?.idClient : selectedClientData;

  const { t } = useTranslation();

  const { toggleCreateModal } = useContext(CreateModalContext);

  const handleAddClient = (e) => {
    e.stopPropagation();
    toggleCreateModal(
      <CreateClientComponent
        onClose={() => {
          toggleCreateModal(<></>);
        }}
      />,
      t("client.create_form.title")
    );
  };
  console.log("ffffffffffffffffff", selectedClientData);
  return (
    <Stack
      className="details-company-client"
      sx={{
        backgroundColor: "#f8fbff",
        padding: "1.5rem",
        borderRadius: "16px",
      }}>
      <div className=" details-personnel">
        <p className="detail-title">{t("invoice.details_personnel")}</p>
        <Stack
          sx={{
            display: "flex",
            alignItems: "baseline",
            justifyContent: "space-between",
            flexDirection: "row",
          }}
          className="infos">
          <div className="details-vendeur">
            <InfoSupp
              companyData={companyData}
              selectedClientId={selectedClientId}
              phone={companyData?.phone}
              address={companyData?.address}
              name={companyData?.name}
              email={companyData?.email}
              idUserClient={idUserClient}
            />
          </div>

          <div
            className="detail-client"
            style={{
              display: "flex",
              flexDirection: "row-reverse",
              alignItems: "baseline",
              gap: "1rem",
            }}>
            {/* --- Select entreprise + bouton --- */}
            {isUpdate && initialValues.idClient && (
              <InfoSupp
                selectedClientData={initialValues?.idClient}
                selectedClientId={selectedClientId}
                phone={phone}
                rm={rm}
                siren={siren}
                numTVA={numTVA}
                siret={siret}
                typeClient={typeClient}
                address={address}
                name={name}
                email={email}
                idUserClient={idUserClient}
              />
            )}
            {!idUserClient && (
              <div className="name-selects">
                <AnimatePresence mode="wait">
                  <motion.div
                    key="client-form"
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.3 }}>
                    <div className="input-with-button">
                      <select
                        className="table-input"
                        {...register("idClient")}
                        onChange={(e) => handleClientChange(e.target.value)}
                        required>
                        <option value="">{t("invoice.choose_company")}</option>
                        {clientsData?.map((client) => (
                          <option key={client._id} value={client._id}>
                            {client?.name}
                          </option>
                        ))}
                      </select>

                      <button
                        type="button"
                        className="add-button"
                        onClick={handleAddClient}>
                        +
                      </button>
                    </div>

                    {/* --- Select client + bouton --- */}
                    <p className="mt-3">{t("invoice.recipient")}</p>
                    <div className="input-with-button">
                      <select
                        className="table-input"
                        {...register("idUserClient")}
                        required
                        disabled={!selectedClientId}>
                        <option value="">{t("invoice.choose_client")}</option>
                        {selectedClientData?.userClients?.map((client) => (
                          <option key={client._id} value={client._id}>
                            {client.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </motion.div>
                </AnimatePresence>
              </div>
            )}

            {idUserClient && (
              <AnimatePresence>
                {Object.keys(selectedClientData || {}).length > 0 && (
                  <motion.div
                    key="info-supp"
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.3 }}>
                    <InfoSupp
                      selectedClientData={selectedClientData}
                      selectedClientId={selectedClientId}
                      phone={phone}
                      rm={rm}
                      siren={siren}
                      numTVA={numTVA}
                      siret={siret}
                      typeClient={typeClient}
                      address={address}
                      name={name}
                      email={email}
                      idUserClient={idUserClient}
                    />
                  </motion.div>
                )}
              </AnimatePresence>
            )}
          </div>
        </Stack>
      </div>
    </Stack>
  );
};

export default CompanyClientDetails;
